import React from 'react';
import '../../styles/jisbutton.css';
import DynamicIcon from '../dynamicicon';
import * as Constants from '../../constants';

function JisButton({
  code,
  label,
  type = 'button',
  onClick,
  variant = 'primary',
  loading = false,
  disabled = false,
  fullWidth = false,
  icon = null,
  iconPosition = 'left',
  children,
  isRoleBased=false,
  data=null,
}) {
  const item=Constants.PageDetails(data,'action',code);
  const _loading= loading || (isRoleBased && data==null);

  if (!_loading && isRoleBased && data !== null && !item) return null;
  
  return (
    <button
      type={type}
      className={`jis-button ${variant} ${fullWidth ? 'full-width' : ''}`}
      onClick={onClick}
      disabled={disabled || _loading}
    >
      {(_loading) ? (
        <span className="spinner"></span>
      ) : (
        <>
          {icon && iconPosition === 'left' && (
            <span className="button-icon left"><DynamicIcon iname={item?.icon || icon} /></span>
          )}
         <span>{ item?.name || label || children }</span> 
          {icon && iconPosition === 'right' && (
            <span className="button-icon right"><DynamicIcon iname={item?.icon || icon} /></span>
          )}
        </>
      )}
    </button>
  );
}

export default JisButton;
